import { render } from "./CriteriaForm.vue?vue&type=template&id=7bd578c6"
import script from "./CriteriaForm.vue?vue&type=script&lang=js"
export * from "./CriteriaForm.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__